import React from 'react';

export function RangeSlider({
  label,
  value,
  min = 0,
  max = 100,
  unit = '',
  leftHint,
  rightHint,
  onChange
}) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
        <span style={{ fontSize: '12px', fontWeight: 600, color: '#cbd5e1' }}>{label}</span>
        <span style={{ fontSize: '12px', fontWeight: 700, color: '#c084fc' }}>
          {value}{unit}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      {(leftHint || rightHint) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#64748b', marginTop: '4px' }}>
          <span>{leftHint}</span>
          <span>{rightHint}</span>
        </div>
      )}
    </div>
  );
}
